import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { TicketType } from '../enums/ticketType';

export interface IPatientAccessReasonValidated {
    patientId: string;
    reasonForAccess: string;
    requestId: string | null;
    ticketInformation: string;
    ticketType: TicketType;
}

export const patientAccessReasonSchema: ISchemaContainer<IPatientAccessReasonValidated> = {
    schema: Koi.object({
        patientId: Koi.string().uuid(),
        reasonForAccess: Koi.string().max(255),
        requestId: Koi.string().uuid().allow(null).optional(),
        ticketInformation: Koi.string().max(255),
        ticketType: Koi.koi().enum(TicketType),
    }),
};
